import React from 'react'

import { useLocation } from '@reach/router'
import { Link } from 'gatsby'
import styled, { css } from 'styled-components'

import { Container } from 'src/components/partials/Container'
import { Breakpoints } from 'src/utilities/Breakpoints'
import { BrandColors } from 'src/utilities/Colors'

import { TopHat } from './Typography'
import FaIcon from '../partials/FaIcon'

/* TODO:
  - Rebuild this whole thing with SCSS
*/

// const InvertedContext = React.createContext(false)

const SubNavWrapper = styled.div<{
  inverted: boolean
  backgroundColor?: string
}>`
  background-color: ${({ inverted }) =>
    inverted ? BrandColors.black : BrandColors.white};

  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}
  padding-top: 4.75rem;

  ul {
    display: flex;
    justify-content: center;
    list-style: none;
    gap: 0.5rem;
  }

  a {
    ${({ inverted }) => css`
      color: ${inverted ? '#fff' : '#000'};
    `}
    text-decoration: none;
    padding: 0.5rem;
    border-radius: 0.25rem;
    transition: all 0.2s ease-in-out;
  }

  a:hover,
  a:focus,
  a:active {
    ${({ inverted }) => css`
      color: ${inverted ? BrandColors.primaryAccent : BrandColors.primary};
    `}
  }

  a.is-active {
    font-weight: bold;
  }

  display: none;

  @media (min-width: ${Breakpoints.md}px) {
    display: block;
  }
`

const SubNavContainer = styled.div`
  display: block;
`

const SubNavContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border-bottom: 1px solid
    ${({ inverted }) => (inverted ? BrandColors.white : BrandColors.pigeon300)};
  border-top: 1px solid
    ${({ inverted }) =>
    inverted ? BrandColors.white : BrandColors.pigeon300}; */
  padding: 0.75rem 0;
`

const Logo = styled.div`
  display: flex;
  align-items: center;
  /* width: 2rem; */
  height: 2rem;
`

const LogoIcon = styled.div<{ backgroundColor?: string }>`
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.75rem;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : BrandColors.primaryAccent};
`

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  a {
    position: relative;

    sup {
      position: absolute;
      top: 0rem;
      right: -0.25rem;
      font-size: 0.75rem;
    }
  }
`

const SubNavLogoSVG = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    fill='none'
    viewBox='0 0 20 20'
  >
    <path fill='#FFD152' d='M0 0H20V20H0z'></path>
    <path
      stroke='#000'
      d='M15.5 5v-.5H9.904l.854.854 1.198 1.198-2.393 2.392H3.944v2.112H10.437l.147-.147 2.864-2.865 1.198 1.198.758.758-.758.758-1.198 1.198-1.59-1.591-.354-.354-.354.354-.785.785-.354.354.354.353 1.59 1.591-1.197 1.198-.854.854H15.5V5z'
    ></path>
  </svg>
)

const leftLinksDefault = [
  { label: 'Projects', to: '/platform/projects/' },
  { label: 'Portal', to: '/platform/portal/' }
]

const rightLinksDefault = [
  { label: 'Workbooks', to: '/platform/workbooks/' },
  { label: 'Mapping', to: '/platform/mapping/' },
  { label: 'Orchestration', to: '/platform/orchestration/' },
  { label: 'Plugins', to: '/docs/plugins/overview' }
]

const SubNav = ({
  inverted,
  backgroundColor,
  leftLinks = leftLinksDefault,
  logo = {
    backgroundColor: BrandColors.primaryAccent,
    icon: <SubNavLogoSVG />,
    text: 'Platform',
    linkUrl: '#'
  },
  rightLinks = rightLinksDefault
}: {
  inverted?: boolean
  backgroundColor?: string
  leftLinks?: {
    label: string
    to: string
  }[]
  logo?: {
    backgroundColor?: string
    icon?: React.ReactNode
    text?: string
    linkUrl?: string
    showChevron?: boolean
  }
  rightLinks?: {
    label: string
    to: string
    external?: boolean
  }[]
}) => {
  const location = useLocation()
  // console.log('Current location:', location.pathname)
  // console.log('Inverted:', props.inverted)

  return (
    <SubNavWrapper inverted={inverted} backgroundColor={backgroundColor}>
      <div className='border-t-1 border-gray-500'>
        <SubNavContainer className='max-w-container mx-auto px-4 md:px-16 lg:px-9 flex'>
          <SubNavContent>
            <Logo>
              {/* {logo.icon && (
              <LogoIcon backgroundColor={logo.backgroundColor}>
                {logo.icon}
              </LogoIcon>
            )} */}
              {/* if logo.linkUrl use a link */}
              {logo.linkUrl ? (
                <Link to={logo.linkUrl} className='!p-0'>
                  <TopHat
                    color={inverted ? BrandColors.white : BrandColors.black}
                    case='normal'
                    letterSpacing='normal'
                  >
                    {/* show left chevronm icon if enabled */}
                    {logo.showChevron && (
                      <FaIcon
                        color='currentColor'
                        classes='fa-sharp fa-regular fa-chevron-left mr-2 relative top-[1px]'
                        size='1rem'
                      />
                    )}
                    {logo.text && logo.text}
                  </TopHat>
                </Link>
              ) : (
                <TopHat
                  color={inverted ? BrandColors.white : BrandColors.black}
                  case='normal'
                  letterSpacing='normal'
                >
                  {logo.text && logo.text}
                </TopHat>
              )}
            </Logo>

            <Nav>
              <ul>
                {leftLinks.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.to}
                      className={
                        location.pathname.includes(link.to) ? 'is-active' : ''
                      }
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>

              {rightLinks && (
                <>
                  {' '}
                  |{' '}
                  <ul>
                    {rightLinks.map((link, index) => (
                      <li key={index}>
                        {link.external ? (
                          <a href={link.to} target='_blank' rel='noreferrer'>
                            {link.label}
                            {link.external && <sup>↗</sup>}
                          </a>
                        ) : (
                          <Link
                            to={link.to}
                            className={
                              location.pathname.includes(link.to)
                                ? 'is-active'
                                : ''
                            }
                          >
                            {link.label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </Nav>
          </SubNavContent>
        </SubNavContainer>
      </div>
    </SubNavWrapper>
  )
}

export default SubNav
